import React from 'react';
import { Strong, Text } from 'evergreen-ui';
import { ExtendedDatasourceProps } from './utils';

export function DatasourceName({
  datasource,
}: ExtendedDatasourceProps) {
  return (
    <>
      {
      datasource.serialNum ? (
        <Strong backgroundColor="rgba(16, 112, 202, 0.09)">
          {`[${datasource.serialNum}]`}
        </Strong>
      ) : null
      }
      <Text>{datasource.datasourceTypeShortName}</Text>
    </>
  );
}
export const MemoDatasourceName = React.memo(DatasourceName);
MemoDatasourceName.displayName = 'MemoDatasourceName';
export default DatasourceName;
